import type { AnyAction } from 'redux'

import type { AppDispatch } from '../../store/types'
import {
  FlyoutFunction,
  ProductStatus,
  type CloudMarketplace,
} from '../productsListing/types'
import { getInitalCloudMarketplace } from './utils/getInitalCloudMarketplace'

export { FlyoutFunction }

export enum ProductListingFilterType {
  SET_CLOUD_MARKETPLACE = 'SET_CLOUD_MARKETPLACE',
  SET_CREATE_PRIVATE_OFFER_MODAL_OPEN = 'SET_CREATE_PRIVATE_OFFER_MODAL_OPEN',
}

export const notAllowedProductSelection = [
  ProductStatus.PRODUCT_STATUS_DRAFT,
  ProductStatus.PRODUCT_STATUS_IN_PROGRESS,
  ProductStatus.PRODUCT_STATUS_CREATION_FAILED,
]

export interface ProductListingFilters {
  cloudMarketplace: CloudMarketplace
  createPrivateOfferModalOpen: boolean
}

export type CloudProductFiltersFunctionType =
  | (() => (dispatch: AppDispatch) => Promise<void>)
  | (() => AnyAction)

export interface CloudProductFilters {
  clearData: CloudProductFiltersFunctionType
  setPageAsOne: CloudProductFiltersFunctionType
}

export type ProductFilterListItem = {
  label: string
  value: string
  key: string
}

export type ProductListingFilterAction =
  | {
      type: ProductListingFilterType.SET_CLOUD_MARKETPLACE
      payload: CloudMarketplace
    }
  | {
      type: ProductListingFilterType.SET_CREATE_PRIVATE_OFFER_MODAL_OPEN
      payload: boolean
    }

export const initialState: ProductListingFilters = {
  cloudMarketplace: getInitalCloudMarketplace(),
  createPrivateOfferModalOpen: false,
}
